import React from 'react';

import { salesOrdersContainerConfiguration } from '@totem/components/salesOrders/list/containerConfiguration';
import SalesOrdersContainer from '@totem/components/salesOrders/list/SalesOrdersContainer';
import SalesOrdersLayout from '@totem/components/salesOrders/list/SalesOrdersLayout';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';

const SalesOrdersPage = () => {
  return (
    <ContentLayout>
      <InputContainer
        filterConfig={salesOrdersContainerConfiguration}
        defaultSort={{
          field: 'nsSalesOrder.tranId',
          direction: 'ascend',
        }}
        componentKey={'account.salesOrders'}
      >
        <SalesOrdersContainer>
          <IBCard title="Sales Order Lines" isCovered>
            <SalesOrdersLayout />
          </IBCard>
        </SalesOrdersContainer>
      </InputContainer>
    </ContentLayout>
  );
};

export default SalesOrdersPage;
